import { z } from 'zod';

import {
  CallbacksListResponse,
  CallbacksListResponseItem,
  CallbacksSummaryRetrieveResponse,
} from '~/data/generated/zod/callbacks/callbacks.zod';

export const callbackTicketListSchema = CallbacksListResponse;

export type CallbackTicket = z.infer<typeof CallbacksListResponseItem>;

// The summary carries the window to draw as well as the rows, because the rolling
// window's dates are decided server-side.
export const callbackSummarySchema = CallbacksSummaryRetrieveResponse;

export type CallbackSummaryResponse = z.infer<typeof CallbacksSummaryRetrieveResponse>;
export type CallbackCarSummary = CallbackSummaryResponse['cars'][number];
export type CallbackWindow = CallbackSummaryResponse['window'];
